// extracted by mini-css-extract-plugin
export default {"root":"CashSlot_root__3nThB","stackList":"CashSlot_stackList__gLiM4","stack":"CashSlot_stack__Ekb8P","cashImg":"CashSlot_cashImg__sUSAm"};